// extracted by mini-css-extract-plugin
module.exports = {"date":"RefundsSubSection_date__3BRhR","wrapper":"RefundsSubSection_wrapper__30Wd1"};